// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PickupDropZoneApiModel from "../api-model/PickupDropZoneApiModel.bs.js";
import * as PickupDropClusterApiModel from "../api-model/PickupDropClusterApiModel.bs.js";

function apiModelToState(zones) {
  return List.map((function (z) {
                return {
                        id: z.id,
                        description: z.description
                      };
              }), zones.zones);
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(PickupDropZoneApiModel.t_decode(json), "ZonesAndClustersEntityMapper.re-Zones"));
}

var Zones = {
  apiModelToState: apiModelToState,
  execute: execute
};

function apiModelToState$1(clusters) {
  return List.map((function (z) {
                return {
                        id: z.id,
                        description: z.name,
                        zone_id: z.zone_id
                      };
              }), List.filter(function (cluster) {
                    return cluster.zone_id !== undefined;
                  })(clusters.clusters));
}

function execute$1(json) {
  return apiModelToState$1(DeccoUtils$Catalyst.resolveResult(PickupDropClusterApiModel.t_decode(json), "ZonesAndClustersEntityMapper.re-Clusters"));
}

var Clusters = {
  apiModelToState: apiModelToState$1,
  execute: execute$1
};

export {
  Zones ,
  Clusters ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
